import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppAlertModule } from '@rci/self-serve-fido/shared/app-alert/app-alert.module';
import { NavigationService } from '@rci/self-serve-fido/shared/navigation-service/navigation-service.service';
import { PageAlertModule } from '@rci/self-serve-fido/shared/page-alert/page-alert.module';
import { SubnavModule } from '@rogers/cdk/assembled/subnav';
import { BreadcrumbModule } from '@rogers/cdk/breadcrumb';
import { IconComponent } from '@rogers/cdk/icon';
import { LinkComponent } from '@rogers/cdk/link';
import { ResponsiveModule } from '@rogers/ngx-responsive';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { LogoutComponent } from './logout/logout.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SecondaryNavComponent } from './secondary-nav/secondary-nav.component';
import { WelcomeComponent } from './welcome/welcome.component';

@NgModule({
  declarations: [BreadcrumbsComponent, LogoutComponent, NotFoundComponent, SecondaryNavComponent, WelcomeComponent],
  exports: [BreadcrumbsComponent, SecondaryNavComponent, SubnavModule, WelcomeComponent, PageAlertModule],
  imports: [
    AppAlertModule,
    BreadcrumbModule,
    CommonModule,
    IconComponent,
    LinkComponent,
    ResponsiveModule,
    SubnavModule,
    TranslateModule,
  ],
  providers: [NavigationService],
})
export class CoreModule {}
